/* JOLI POT, aperçu de la carte à planter (assets/jp-carte-apercu.js)
   Code partagé : même rendu que l'aperçu carte du configurateur (assets/jp-configurateur.js, creerApercuCarte).
   Chargé par snippets/jp-carte-apercu.liquid, qui fournit window.JP_CARTE (URL des polices, logo, photo en situation).
   Utilisation :
     var ap = JPCarte.creer();               // une carte à plat (papier ensemencé, cœur, logo)
     conteneur.appendChild(ap.el);
     ap.maj({ texte: '...', signature: '...', style: JPCarte.STYLES[0] });
     JPCarte.situation(ap)                   // fenêtre « en situation » (photo réglée dans Paramètres du thème) */
(function () {
  if (window.JPCarte) return;
  var R = window.JP_CARTE || {};

  /* Styles d'écriture proposés (police, nom affiché, taille max en % de la largeur de carte) : identiques au configurateur */
  var STYLES = [
    { police: 'Orwell', nom: 'Joli Pot', plafond: 4.2 },
    { police: 'Great Vibes', nom: 'Élégant', plafond: 6 },
    { police: 'Sacramento', nom: 'Doux', plafond: 6.5 },
    { police: 'Caveat', nom: 'Naturel', plafond: 5 },
    { police: 'Dancing Script', nom: 'Joyeux', plafond: 5 }
  ];
  /* Taille du texte : 0.8 = 80 % de la taille maximale du configurateur (window.JP_CARTE_ECHELLE pour la changer, par ex. dans un bloc Liquid) */
  var ECHELLE = window.JP_CARTE_ECHELLE || R.echelle || 0.8;
  var VIDE = R.vide || 'Votre message ici';
  var COEUR = '<svg viewBox="0 0 100 90" aria-hidden="true"><path fill="#8c3f34" d="M50 88C47 85 6 58 4 30 2 13 14 2 28 2c11 0 18 7 22 15 4-8 11-15 22-15 14 0 26 11 24 28-2 28-43 55-46 58z"/></svg>';
  var cartes = [], gen = 0;

  /* Polices chargées une seule fois, l'aperçu se redessine quand elles arrivent */
  var policesOk = false;
  function polices() {
    if (policesOk) return; policesOk = true;
    var urls = R.polices || {};
    if (!document.getElementById('jp-ca-polices')) {
      var st = document.createElement('style');
      st.id = 'jp-ca-polices';
      st.textContent = STYLES.filter(function (s) { return urls[s.police]; })
        .map(function (s) { return '@font-face{font-family:"' + s.police + '";src:url(' + urls[s.police] + ') format("woff2");font-display:swap}'; }).join('');
      document.head.appendChild(st);
    }
    if (document.fonts && document.fonts.load) {
      /* 27/10/2026 : un seul recalcul quand toutes les polices sont arrivées (avant : un par police, 5 recalculs lourds) */
      Promise.all(STYLES.map(function (s) { return document.fonts.load('20px "' + s.police + '"').catch(function () {}); }))
        .then(function () { gen++; requestAnimationFrame(function () { cartes.forEach(function (c) { remplir(c); }); }); });
    }
  }

  /* Une carte (texte, cœur, signature) : à plat dans la page, ou posée sur la photo dans la fenêtre */
  function fabriquer(avecPapier) {
    var el = document.createElement('div');
    el.className = 'jp-ca__carte';
    el.innerHTML = (avecPapier ? '<canvas aria-hidden="true"></canvas>' : '') +
      '<div class="jp-ca__zone"><div class="jp-ca__texte"></div><span class="jp-ca__coeur">' + COEUR + '</span><div class="jp-ca__signature"></div></div>' +
      (avecPapier && R.logo ? '<img class="jp-ca__logo" alt="Joli Pot" src="' + R.logo + '">' : '');
    var c = {
      el: el, cv: el.querySelector('canvas'), zone: el.querySelector('.jp-ca__zone'),
      txt: el.querySelector('.jp-ca__texte'), coeur: el.querySelector('.jp-ca__coeur'), sig: el.querySelector('.jp-ca__signature'),
      etat: { texte: '', signature: '', style: STYLES[0] }, vu: true
    };
    return c;
  }

  /* Petits points du papier ensemencé, toujours le même dessin */
  function mouchetis(c) {
    if (!c.cv) return;
    var w = c.el.offsetWidth, h = c.el.offsetHeight, d = window.devicePixelRatio || 1;
    if (!w) return;
    c.cv.width = w * d; c.cv.height = h * d;
    var g = c.cv.getContext('2d'); g.scale(d, d); g.clearRect(0, 0, w, h);
    var s = 7; function rnd() { s = (s * 16807) % 2147483647; return s / 2147483647; }
    for (var i = 0; i < 90; i++) {
      var x = rnd() * w, y = rnd() * h, t = 0.5 + rnd() * 1.6;
      g.fillStyle = 'rgba(120,128,110,' + (0.25 + rnd() * 0.45) + ')';
      g.beginPath(); g.arc(x, y, t, 0, Math.PI * 2); g.fill();
    }
  }

  /* Plus grande taille de texte qui tient dans la zone, signature toujours plus petite que le message */
  function remplir(c) {
    if (!c.vu) return;
    var W = c.el.offsetWidth;
    if (!W) return;
    var e = c.etat, v = String(e.texte || '').trim(), st = e.style || STYLES[0];
    /* 27/10/2026 : rien à recalculer si la largeur, le texte, la signature, le style et les polices n'ont pas changé */
    var cle = W + '|' + gen + '|' + v + '|' + (e.signature || '') + '|' + st.police;
    if (c.cle === cle) return;
    c.cle = cle;
    c.txt.textContent = v || VIDE;
    c.txt.classList.toggle('is-vide', !v);
    c.sig.textContent = String(e.signature || '').trim();
    var police = '"' + st.police + '", cursive';
    c.txt.style.fontFamily = police;
    c.sig.style.fontFamily = police;
    var sigMax = W * 0.045;
    c.sig.style.fontSize = sigMax + 'px';
    var zh = c.zone.clientHeight, zw = c.zone.clientWidth;
    var h = zh - c.coeur.offsetHeight - c.sig.offsetHeight - zh * (c.sig.textContent ? 0.24 : 0.12);
    var lo = 6, hi = Math.min(W * st.plafond * ECHELLE / 100, h), best = lo;
    for (var k = 0; k < 12; k++) {
      var mid = (lo + hi) / 2;
      c.txt.style.fontSize = mid + 'px';
      if (c.txt.scrollHeight <= h && c.txt.scrollWidth <= zw) { best = mid; lo = mid; } else { hi = mid; }
    }
    c.txt.style.fontSize = best + 'px';
    c.sig.style.fontSize = Math.min(sigMax, best * 0.85) + 'px';
  }

  function creer() {
    var c = fabriquer(true);
    cartes.push(c);
    var largeur = 0;
    function surTaille() {
      if (c.el.offsetWidth === largeur) return;
      largeur = c.el.offsetWidth;
      mouchetis(c); remplir(c);
    }
    if (window.ResizeObserver) new ResizeObserver(surTaille).observe(c.el);
    /* 27/10/2026 : une carte loin de l'écran n'est calculée qu'à l'approche (avant : toutes les cartes de la page au chargement) */
    if (window.IntersectionObserver) {
      c.vu = false;
      var io = new IntersectionObserver(function (l) { if (!l[0].isIntersecting) return; io.disconnect(); c.vu = true; largeur = 0; surTaille(); }, { rootMargin: '400px 0px' });
      io.observe(c.el);
    }
    else window.addEventListener('resize', surTaille);
    return {
      el: c.el,
      carte: c,
      maj: function (etat) {
        for (var k in etat) c.etat[k] = etat[k];
        if (c.etat.texte) polices();
        remplir(c);
        if (fen && !fen.hidden) placer();
      }
    };
  }

  /* Fenêtre « en situation » : la carte posée sur la photo, en suivant ses 4 coins */
  var coins = String(R.coins || '').split('|').map(function (p) { return p.split(',').map(parseFloat); })
    .filter(function (p) { return p.length === 2 && !isNaN(p[0]) && !isNaN(p[1]); });
  function homographie(src, dst) {
    var A = [], B = [], i, c, r, k;
    for (i = 0; i < 4; i++) {
      var x = src[i][0], y = src[i][1], u = dst[i][0], v = dst[i][1];
      A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); B.push(u);
      A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); B.push(v);
    }
    for (c = 0; c < 8; c++) {
      var piv = c;
      for (r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[piv][c])) piv = r;
      var t = A[c]; A[c] = A[piv]; A[piv] = t; t = B[c]; B[c] = B[piv]; B[piv] = t;
      for (r = 0; r < 8; r++) {
        if (r === c) continue;
        var f = A[r][c] / A[c][c];
        for (k = c; k < 8; k++) A[r][k] -= f * A[c][k];
        B[r] -= f * B[c];
      }
    }
    var hh = B.map(function (b, j) { return b / A[j][j]; });
    return [hh[0], hh[3], 0, hh[6], hh[1], hh[4], 0, hh[7], 0, 0, 1, 0, hh[2], hh[5], 0, 1];
  }
  var fen = null, posee = null, photoFen = null, source = null;
  function placer() {
    if (!fen || fen.hidden || coins.length !== 4 || !source) return;
    posee.etat = source.carte.etat;
    remplir(posee);
    var pw = photoFen.clientWidth, ph = photoFen.clientHeight, W = posee.el.offsetWidth, H = posee.el.offsetHeight;
    if (!pw || !W) return;
    var dst = coins.map(function (p) { return [p[0] / 100 * pw, p[1] / 100 * ph]; });
    posee.el.style.transform = 'matrix3d(' + homographie([[0, 0], [W, 0], [W, H], [0, H]], dst).join(',') + ')';
  }
  function fermer() {
    if (!fen) return;
    fen.hidden = true;
    document.documentElement.classList.remove('jp-ca-ouvert');
  }
  function situation(ap) {
    if (!R.photo) return;
    source = ap;
    if (!fen) {
      fen = document.createElement('div');
      fen.className = 'jp-ca-fen';
      fen.setAttribute('role', 'dialog');
      fen.setAttribute('aria-modal', 'true');
      fen.innerHTML = '<div class="jp-ca-fen__boite"><button type="button" class="jp-ca-fen__x" aria-label="Fermer">×</button>' +
        '<div class="jp-ca-fen__photo"><img alt="" src="' + R.photo + '"></div></div>';
      photoFen = fen.querySelector('.jp-ca-fen__photo');
      posee = fabriquer(false);
      photoFen.appendChild(posee.el);
      fen.addEventListener('click', function (e) { if (e.target === fen || e.target.closest('.jp-ca-fen__x')) fermer(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); });
      fen.querySelector('img').addEventListener('load', placer);
      window.addEventListener('resize', placer);
      document.body.appendChild(fen);
    }
    fen.hidden = false;
    document.documentElement.classList.add('jp-ca-ouvert');
    placer();
  }

  window.JPCarte = { STYLES: STYLES, creer: creer, polices: polices, situation: situation, aPhoto: !!R.photo };
})();
